import React, { useContext, useEffect } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { createLocationFormData } from '../../../data/formData';
import StepLocationDetails from '../createLocation/StepLocationDetails';
import { apiConstants } from '../../../utils/apiConstants';
import { emptyFunction, getCompanyName, showToast, validatePhoneNumber } from '../../../utils';
import { errorMessage } from '../../../utils/constants';
import { DateUtils } from '../../../utils/dateUtils';
import { MyContext } from '../../../context';
import { makePatchCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType } from '../../../types';

interface IUpdateLocation {
    onClose: () => void;
    onUpdate: () => void;
    locationData: any
}

const UpdateLocation = (props: IUpdateLocation) => {

    const { userData } = useContext(MyContext)

    const { ...createLocData } = useForm({
        mode: 'all',
        defaultValues: { ...createLocationFormData(props?.locationData || {}) },
        reValidateMode: 'onBlur',
    });

    const onSubmit: SubmitHandler<any> = (data: any) => {
        const createLocPayload: any = { ...createLocData.getValues() };
        if (createLocPayload[apiConstants.contact_phone_number]) {
            createLocPayload[apiConstants.contact_phone_number] = `${createLocPayload?.dial_code?.dial_code}${createLocPayload?.[apiConstants.contact_phone_number]}`;
            if (!validatePhoneNumber(createLocPayload?.[apiConstants.contact_phone_number])) {
                showToast(errorMessage.invalid_mobile_msg, 'error', 'mobile')
                return
            }
        }
        createLocPayload[apiConstants.date_scouted] = createLocPayload[apiConstants.date_scouted] ? DateUtils.formatDateTime(createLocPayload[apiConstants.date_scouted], 'YYYY-MM-DD') : ''
        createLocPayload.production_company_name = getCompanyName(userData);
        delete createLocPayload.dial_code;
        updateLoc(createLocPayload)
    };

    const updateLoc = (payload: any) => {
        const url = `${endPoints.LOCATION}${props?.locationData?.id}/`
        makePatchCall(url, payload).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message || '', 'success')
                props?.onUpdate();
            }
        }).catch(emptyFunction);
    }

    useEffect(() => {
        if (props?.locationData?.id) {
            const obj = createLocationFormData(props?.locationData || {})
            createLocData.reset(obj)
        }
    }, [props?.locationData])

    return (
        <div>
            <div className="lcs-backdrop" onClick={props.onClose} />
            <div className="lcs-edit-drawer">
                <div className="lcs-edit-drawer__header">
                    <button className="lcs-edit-drawer__close" onClick={props.onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="lcs-edit-drawer__title">Edit Location Information</h2>
                </div>

                <div className="lcs-edit-drawer__body">
                    <StepLocationDetails createLocData={createLocData} />
                </div>

                <div className="lcs-edit-drawer__footer">
                    <button className="lcs-edit-drawer__save-update" onClick={createLocData.handleSubmit(onSubmit)}>
                        Save &amp; Update
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UpdateLocation